<template>
  <div>
    <iframe
      :id="id"
      class="position-absolute border-0"
      style="left: 0; top: -30px;"
      :src="webcamSrc + '&enablejsapi=1&origin=' + location+'&bust=' + cacheBuster"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      height="1080"
      width="1920"
      allowfullscreen
    />
  </div>
</template>

<script>
export default {
  name: 'Webcam',
  props: {
    webcamSrc: {
      type: String,
      default: '',
    },
    cacheBuster: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      id: Math.random().toString(36).substring(7),
      player: undefined,
      location: window.location.origin,
    };
  },
  mounted() {
    const vm = this;
    const getYT = setInterval(() => {
      if (window.YT) {
        vm.setPlayer();
        clearInterval(getYT);
      }
    }, 1000);
  },
  methods: {
    setPlayer() {
      const vm = this;
      this.player = new window.YT.Player(
        this.id,
        {
          events: {
            onReady: () => {
              vm.player.setPlaybackRate(2);
            },
          },
        },
      );
    },
  },
};
</script>
